import React, { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

export const Image = ({
  src,
  title,
  caption,
  source,
  colorMode = 'light',
}: {
  src?: string
  title?: string
  caption?: string
  source?: string
  colorMode?: 'light' | 'dark'
}) => {
  const { width } = useWindowSize()
  const content = (
    <FigCaption>
      {title && <Title>{title}</Title>}
      {caption && <Caption>{caption}</Caption>}
      {source && <Source>{source}</Source>}
    </FigCaption>
  )
  return (
    <>
      <Figure>
        {!src && <Placeholder />}
        {src && <_Image src={src} />}
        {content}
      </Figure>
    </>
  )
}

const Placeholder = styled.div`
  width: 100%;
  height: 400px;
  background-color: #e9e9e9;
`
const Figure = styled.figure`
  max-width: 100%;

  margin-bottom: 60px;
  line-height: 0;
  width: 100vw;
  margin: 0;
  margin-bottom: 60px;
  margin-top: 30px;

  @media only screen and (max-width: 712px) {
    /* max-width: 100vw; */
    margin-bottom: 30px;
  }
`
const FigCaption = styled.figcaption`
  padding-top: 1.5rem;
  font-size: 15px;
  line-height: 21px;
  color: var(--text-color);
  font-family: var(--font-plex);
`
const Title = styled.div`
  font-weight: 700;
`
const Caption = styled.div`
font-size: 15px;
  margin-bottom:8px ;
`
const Source = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: var(--gray-3);
`

const _Image = styled.img`
  max-width: 100%;
  @media only screen and (max-width: 711px) {
    margin-left: -2rem;
    max-width: calc(100% + 4rem);

    /* margin-left: -2.7rem; */
    /* width: calc(100% + 5.4rem);
    max-width: calc(100% + 5.4rem); */
  }
`
